import styled from "styled-components";
import NumberFormat from "react-number-format";
import DatePicker from "react-datepicker";
import { errorColor, bodyColor } from "../../../../config/constants";
import { relativeButtonIndex, patientSkinColorIndex } from "../../../../config/zIndex";

export const PersonalInformationDiv = styled.div`
  width: 100%;
  max-width: 860px;
  padding: 15px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const TitleTextDiv = styled.div`
  display: flex;
  justify-content: flex-start;
`;
export const DataDiv = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  @media (max-width: 910px) {
    flex-direction: column;
    align-items: center;
  }
`;
export const ColumnDataDiv = styled.div`
  width: ${({ width }) => width && width};
  display: flex;
  flex-direction: column;
  @media (max-width: 910px) {
    width: 220px;
  }
`;
export const InputDataDiv = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "center")};
  justify-content: flex-end;
  position: relative;
  @media (max-width: 910px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const Label = styled.label`
  margin-right: 15px;
  font-size: 14px;
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : "normal")};
  text-align: right;
`;
export const Input = styled.input`
  padding: ${({ padding }) => (padding ? padding : "5px 10px")};
  width: 200px;
  border: ${({ error }) => (error ? `1px solid ${errorColor}` : `1px solid ${bodyColor}`)};
  outline: none;
  border-radius: 5px;
  font-size: 14px;
`;
export const RelativeButton = styled.button`
  width: 23px;
  height: 23px;
  position: absolute;
  top: 3px;
  right: 5px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  z-index: ${relativeButtonIndex};
  @media (max-width: 910px) {
    top: 21px;
    right: 26px;
  }
`;
export const InputStartingDateDiv = styled.div`
  width: 200px;
`;
export const InputStartingDate = styled(DatePicker)`
  padding: 5px 10px;
  width: 200px;
  border: ${({ border }) => border && border};
  outline: none;
  border-radius: 5px;
  font-size: 14px;
`;
export const InputBirthday = styled(NumberFormat)`
  padding: 5px 10px;
  width: 200px;
  border: ${({ error }) => error && error};
  outline: none;
  border-radius: 5px;
  font-size: 14px;
`;
export const Textarea = styled.textarea`
  padding: 5px 10px;
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  min-height: 80px;
  max-height: 105px;
  border: 1px solid ${bodyColor};
  outline: none;
  border-radius: 5px;
  font-size: 12px;
`;
export const SkinColorContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const HandsContainer = styled.div`
  width: 200px;
  display: flex;
  justify-content: space-between;
`;
export const SkinColorCheckboxContainer = styled.div`
  padding-right: 2px;
  width: 36px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${({ verifySkinColor }) => (verifySkinColor ? "1px solid #fff" : "1px solid #ccc")};
  border-radius: 8px;
  position: relative;
`;
export const SkinColorCheckbox = styled.input`
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
  position: absolute;
  z-index: ${patientSkinColorIndex};
`;
export const SkinColorImg = styled.img`
  height: ${({ verifySkinColor }) => verifySkinColor && "100%"};
`;
export const SkinColorChecked = styled.img`
  width: 16px;
  height: 13px;
  position: absolute;
  right: 7px;
  bottom: 5px;
`;
